import { FC } from "react";

import { BaseProps } from "capitalrx-components-2.0/lib/BaseProps";
import { AccessibilityProps } from "capitalrx-components-2.0/lib/AccessibilityProps";
import { getHtmlPropsFromBaseProps } from "capitalrx-components-2.0/lib/utilities";

import styles from "./styles.module.scss";

export interface HorizontalLineProps extends BaseProps, AccessibilityProps {}

export const HorizontalLine: FC<HorizontalLineProps> = (props) => {
  const { className, role="separator" } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.HorizontalLine, className],
    testIdPrefix: "horizontal_line",
  });

  return <hr {...baseHtmlProps} role={role} />;
};
